@if (loading) {
  <div class="dark-overlay">
    <div class="loading-message">
      <mat-spinner></mat-spinner>
      {{ message }}
    </div>
  </div>
}
